import React, { useState, useEffect, useRef } from "react";
import TrainingForm from "./components/TrainingForm";
import TrainingList from "./components/TrainingList";
import TrainingChart from "./components/TrainingChart";
import PlanSetupProgramNavigation from "./components/PlanSetupProgramNavigation";
import HomeTrainer from "./components/HomeTrainer";
import HomeTrainerMobile from "./components/HomeTrainerMobile";
import AppFooter from "./components/Footer";
import LoginForm from "./components/Login";
import TrainingSummary from "./components/DataAnalysis.js";
import Sidebar from "./components/Sidebar";
import PlanSetup from "./components/PlanSetup";
import AiPlansBuilder from "./components/AiPlansBuilder";
import AiIndividualSessionBuilder from "./components/AiIndividualSessionBuilder";
import LiquidGlass from "./components/LiquidGlass";
import {
  Button,
  Input,
  Form,
  Select,
  Typography,
  Row,
  Col,
  Modal,
  Checkbox,
  Tooltip,
  Spin,
} from "antd";
import {
  ReloadOutlined,
  HeartFilled,
  HeartOutlined,
  BugOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import axios from "axios";
import "./App.css"; // Make sure to import your CSS file
import logo from "./logo_no_bg.png";
import logoTurnPhone from "./turnPhone.png";
import { Layout } from "antd";
import History from "./components/History";
import FileImporter from "./components/FileImporter";
import UpdateMessageModal from "./components/UpdateMessageModal";
import { useDialog } from "./components/DialogProvider";
import { InstallProvider } from "./components/InstallProvider";
import Profile from "./components/Profile";
import AdminDashboard from "./components/AdminDashboard";
import AdminUserHistory from "./components/AdminUserHistory";
import FeedbackBugReports from "./components/FeedbackBugReports";
import { DEV_FEEDBACK_ATTENTION_ITEMS, useDevFeedback } from "./components/DevFeedback";
import WorkoutParser from "./components/WorkoutParser";
import LandingPage from "./components/LandingPage";
import { syncAiDraftCacheFromUserInfo } from "./utils/aiDraftCache";
import { resolveStepMode, STEP_MODE } from "./utils/ergMode";
// ...later
const { Content } = Layout;

const { Option } = Select;
const { Title, Text } = Typography;

const isLocal = window.location.origin.includes("localhost");
const backendBaseUrl = isLocal ? "http://localhost:8000" : "";

function AppMain() {
  const { alert: alertDlg, confirm } = useDialog();
  const planSetupRightStackRef = useRef(null);
  const [planSetupRightStackHeight, setPlanSetupRightStackHeight] = useState(null);
  const [suppressGlobalModals, setSuppressGlobalModals] = useState(false);
  const [steps, setSteps] = useState([]);
  const [rideOutsideProposed, setRideOutsideProposed] = useState(() => {
    try {
      const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
      const storedDate = localStorage.getItem("rideOutsideModalLastShownDate");
      let shownToday = storedDate === today;

      // Backward compatibility with legacy timestamp key
      if (!shownToday) {
        const legacyTs = Number(localStorage.getItem("rideOutsideModalLastShownAt") || "0");
        if (legacyTs) {
          const legacyDate = new Date(legacyTs).toISOString().slice(0, 10);
          shownToday = legacyDate === today;
        }
      }

      return { fetched: false, shown: shownToday };
    } catch (e) {
      return { fetched: false, shown: false };
    }
  });
  const [plansInfo, setPlansInfo] = useState([]);
  const [arePlansLoading, setArePlansLoading] = useState(false);
  const [FTP, setFTP] = useState(null);
  const [weight, setWeight] = useState(null);
  const [stepIndex, setStepIndex] = useState(0);
  const [planName, setPlanName] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const [feedbackMode, setFeedbackMode] = useState("feedback"); // "feedback" | "bug"
  const [feedbackInitialText, setFeedbackInitialText] = useState("");
  const [initialBugScreenshot, setInitialBugScreenshot] = useState(null);
  const [isModificationMade, setIsModificationMade] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState({ uuid: 1 });
  const [username, setUsername] = useState(null);
  const [otherUserInfo, setOtherUserInfo] = useState({});
  const [nextSessionUuid, setNextSessionUuid] = useState(null);
  const [usernameToFetch, setUsernameToFetch] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isPremium, setIsPremium] = useState(false);
  const [isBetaTester, setIsBetaTester] = useState(false);
  const [favouritePlans, setFavouritePlans] = useState([]);
  const [refFTPForAdjust, setRefFTPForAdjust] = useState(FTP);
  const [lastNon100FTP, setLastNon100FTP] = useState(FTP !== 100 ? FTP : null);
  const [planDescription, setPlanDescription] = useState(null);
  const [planCategory, setPlanCategory] = useState(null);
  const [previousUuid, setPreviousUuid] = useState(null);
  const [planStressPoints, setPlanStressPoints] = useState(0);
  const [planIsFavourite, setPlanIsFavourite] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isLandscape, setIsLandscape] = useState(true);
  const [history, setHistory] = useState([]);
  const [progressCount, setProgressCount] = useState(null); // number | null (unknown until first refresh)
  const [reloadTs, setReloadTs] = useState(Date.now());
  const [powerUnit, setPowerUnit] = useState("watts"); // "watts" | "percent" (display/input mode only; steps are always stored in watts)
  const [disabledPhoneButton, setDisabledPhoneButton] = useState(false);
  const [isMute, setIsMute] = useState(true);
  const [activeKey, setActiveKey] = useState("1");
  const [siderCollapsed, setSiderCollapsed] = useState(true);
  const [showTrainingForm, setShowTrainingForm] = useState(false);
  const [planChangeWarningOpen, setPlanChangeWarningOpen] = useState(false);
  const [suppressPlanChangeThisSession, setSuppressPlanChangeThisSession] = useState(false);
  const [planSavedModalOpen, setPlanSavedModalOpen] = useState(false);
  const [isSelectingPlan, setIsSelectingPlan] = useState(false);
  const [isRefreshingHistory, setIsRefreshingHistory] = useState(false);
  const [isBootstrappingUserInfo, setIsBootstrappingUserInfo] = useState(false);
  const [adminUserHistoryUsername, setAdminUserHistoryUsername] = useState(null);
  const [isBugButtonHovered, setIsBugButtonHovered] = useState(false);
  const [nextSessionPromptPlan, setNextSessionPromptPlan] = useState(null);
  const nextSessionPromptShownUuidRef = useRef(null);


  // AI Plan Builder (program) - rendered as a full page (not a modal)
  const [aiCoachLoading, setAiCoachLoading] = useState(false);
  const [aiCoachIntroMessage, setAiCoachIntroMessage] = useState("");
  const [aiBuilderInitialState, setAiBuilderInitialState] = useState(null);
  const [aiCoachBootstrap, setAiCoachBootstrap] = useState(null); // { user_ftp, is_premium, is_admin, credits_remaining, credits_limit }
  // Simpl'AI Single Workout Builder (single session) - rendered as a full page (not a modal)
  const [aiSingleLoading, setAiSingleLoading] = useState(false);
  const [aiSingleIntroMessage, setAiSingleIntroMessage] = useState("");
  const [aiSingleBuilderInitialState, setAiSingleBuilderInitialState] = useState(null);
  const [aiSingleBootstrap, setAiSingleBootstrap] = useState(null); // { user_ftp, is_premium, is_admin, credits_remaining, credits_limit }

  // Patch console early so logs are captured across the app lifecycle
  useEffect(() => {
    try {
      if (!window.__srConsolePatched) {
        window.__srConsolePatched = true;
        window.__srConsoleLogs = window.__srConsoleLogs || [];
        ["log", "warn", "error", "info"].forEach((lvl) => {
          const orig = console[lvl];
          console[lvl] = (...args) => {
            try {
              const ts = new Date().toISOString();
              const serialized = args
                .map((a) => {
                  try {
                    if (typeof a === "string") return a;
                    return JSON.stringify(a);
                  } catch {
                    return String(a);
                  }
                })
                .join(" ");
              window.__srConsoleLogs.push(`[${ts}] [${lvl.toUpperCase()}] ${serialized}`);
              if (window.__srConsoleLogs.length > 2000) {
                window.__srConsoleLogs.splice(0, window.__srConsoleLogs.length - 2000);
              }
            } catch { }
            try {
              orig.apply(console, args);
            } catch { }
          };
        });
      }
    } catch { }
  }, []);
  // Persist the moment the "ride outside" modal becomes eligible to show (once per day)
  useEffect(() => {
    console.log("otherUserInfo", otherUserInfo);
    const shouldShowRideOutsideModal =
      (otherUserInfo?.shouldRideOutside || 0) > 90 && !rideOutsideProposed.shown && !suppressGlobalModals;

    if (shouldShowRideOutsideModal) {
      try {
        const today = new Date().toISOString().slice(0, 10);
        const storedDate = localStorage.getItem("rideOutsideModalLastShownDate");
        if (storedDate !== today) {
          localStorage.setItem("rideOutsideModalLastShownDate", today);
        }
        // Clean up legacy key if present
        localStorage.removeItem("rideOutsideModalLastShownAt");
      } catch (e) {
        // ignore storage errors
      }
    }
  }, [otherUserInfo?.shouldRideOutside, rideOutsideProposed.shown, suppressGlobalModals]);

  // Apply background to body for proper fixed attachment and full-page coverage
  useEffect(() => {
    try {
      const style = document.body.style;
      if (otherUserInfo?.bgUrl) {
        style.backgroundImage = `url(${otherUserInfo.bgUrl})`;
        style.backgroundSize = "cover";
        style.backgroundPosition = "top center";
        style.backgroundAttachment = "fixed";
        style.backgroundRepeat = "no-repeat";
      } else {
        style.backgroundImage = "";
        style.backgroundSize = "";
        style.backgroundPosition = "";
        style.backgroundAttachment = "";
        style.backgroundRepeat = "";
      }
    } catch (e) {
      // ignore
    }
  }, [otherUserInfo?.bgUrl]);

  // Update lastNon100FTP whenever FTP changes to a non-100 value
  useEffect(() => {
    if (FTP !== 100 && FTP !== lastNon100FTP) {
      setLastNon100FTP(FTP);
    }
  }, [FTP, lastNon100FTP]);

  const useBeforeUnload = (handler) => {
    useEffect(() => {
      const handleBeforeUnload = (event) => {
        const returnValue = handler();
        if (returnValue) {
          event.preventDefault();
          event.returnValue = returnValue; // Standard for older browsers
          return returnValue; // Standard for newer browsers
        }
      };

      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }, [handler]);
  };

  // Usage in your component
  useBeforeUnload(() => {
    if (username) {
      return "Are you sure you want to leave?";
    }
    return undefined; // No message if username is falsy
  });

  useEffect(() => {
    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      console.log("checking if mobile mode...", userAgent);
      // Regular expression to check if the user agent corresponds to a mobile device
      if (/android|iPad|iPhone|iPod/i.test(userAgent) && !window.MSStream) {
        console.log("Mobile mode");
        setIsMobile(true);
        window.addEventListener("resize", function () {
          setIsLandscape(window.innerHeight < window.innerWidth);//always landscape as it's in the manifest.json, no need anymore
        });
        //checking if not mobile, seems weird but to be sure we show the message only once
        if (/iPad|iPhone|iPod/i.test(userAgent) && !window.MSStream) {
          alertDlg(
            "Oops! It looks like iOS devices (iPhone, iPad) don’t support Bluetooth on web apps. Unfortunately, this means you won’t be able to connect your home trainer. But don’t worry! You can still use your computer, including MacBooks, for a seamless experience. Quick reminder: while MacOS > Windows, we all know Android > iOS ;)",
            {
              title: "iOS Bluetooth limitation",
              reportBug: {
                alertName: "App: iOS detected (Bluetooth not supported on web apps)",
                fields: ["Device type (iPhone / iPad / Other)"],
                placeholder: "Please confirm:\n- iPhone\n- iPad\n- Other (which?)\n\nOptional: iOS version + browser (ex: iOS 18.2, Safari)",
                sendText: "Send info",
              },
            }
          );
        }
      } else {
        console.log("Not mobile");
        setIsMobile(false);
        setIsLandscape(true);
      }
    };

    checkMobile();
  }, []);

  useEffect(() => {
    // Keep default behavior from Tabs: desktop -> "1", mobile -> "3"
    setActiveKey(isMobile ? "3" : "1");
  }, [isMobile]);

  // Keep TrainingList height exactly aligned with the right stack (Program nav + Chart),
  // because the nav can appear/disappear depending on editing state.
  useEffect(() => {
    const el = planSetupRightStackRef.current;
    if (!el) return;
    if (typeof ResizeObserver === "undefined") return;

    const update = () => {
      try {
        const h = el.getBoundingClientRect().height;
        setPlanSetupRightStackHeight(h && h > 0 ? Math.ceil(h) : null);
      } catch {
        setPlanSetupRightStackHeight(null);
      }
    };
    update();
    const ro = new ResizeObserver(() => update());
    ro.observe(el);
    return () => {
      try {
        ro.disconnect();
      } catch { }
    };
  }, [activeKey, isMobile, showTrainingForm, steps, FTP]);

  useEffect(() => {
    // Deep-link support: /app?tab=spotify should open the training screen (HomeTrainer),
    // which now contains the Spotify sub-tab.
    try {
      const sp = new URLSearchParams(window.location.search || "");
      const tab = (sp.get("tab") || "").toLowerCase();
      if (tab === "spotify") {
        setActiveKey(isMobile ? "3" : "2");
      }
    } catch { }
  }, [isMobile]);

  const axiosInstance = axios.create({
    baseURL: "/api", // Adjust this baseURL to where your backend is hosted
    headers: {
      "Content-Type": "application/json",
    },
  });

  // Attach token to every request if available. Logic needs to be updated in SaveTraining.js as well
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // --- AI Plan Builder (program) page wiring (must come after axiosInstance is defined) ---
  const persistAiBuilderState = React.useCallback(
    (nextState) => {
      // Allow clearing the persisted AI builder draft (e.g. after final save)
      if (nextState == null) {
        try {
          setAiBuilderInitialState(null);
        } catch { }
        // Keep localStorage cache in sync (program builder only; do NOT touch single-session keys)
        try {
          localStorage.setItem("last_ai_plan_builder_cache", JSON.stringify(null));
          localStorage.setItem("has_ongoing_ai_plan_builder_cache", JSON.stringify(false));
        } catch { }
        try {
          setOtherUserInfo((prev) => ({
            ...(prev || {}),
            lastAiPlanBuilder: null,
            hasOngoingAiPlanBuilder: false,
          }));
        } catch { }
        return;
      }
      if (typeof nextState !== "object") return;
      try {
        setAiBuilderInitialState(nextState);
      } catch { }
      try {
        const isOngoing = (nextState.status || "in_progress") === "in_progress";
        // Keep localStorage cache in sync (program builder only; do NOT touch single-session keys)
        try {
          localStorage.setItem("last_ai_plan_builder_cache", JSON.stringify(nextState));
          localStorage.setItem("has_ongoing_ai_plan_builder_cache", JSON.stringify(Boolean(isOngoing)));
        } catch { }
        setOtherUserInfo((prev) => ({
          ...(prev || {}),
          lastAiPlanBuilder: nextState,
          hasOngoingAiPlanBuilder: Boolean(isOngoing),
        }));
      } catch { }
    },
    [setOtherUserInfo]
  );

  const goToAiPlanBuilder = () => setActiveKey("ai_plan_builder");

  const openAiPlanBuilderProgram = ({ clearExistingDraft = false } = {}) => {
    setAiBuilderInitialState(null);
    setAiCoachIntroMessage("");
    setAiCoachBootstrap(null);
    setAiCoachLoading(true);
    goToAiPlanBuilder();

    (async () => {
      try {
        if (clearExistingDraft) {
          try {
            await axiosInstance.post("/ai/plan_builder/complete/", {});
          } catch {
            // ignore
          }
          try {
            persistAiBuilderState(null);
          } catch {
            // ignore
          }
        }
        const resp = await axiosInstance.post("/ai/plan_builder/intro/", {});
        const intro = (resp?.data?.intro_message || "").trim();
        setAiCoachIntroMessage(intro);
        try {
          const d = resp?.data || {};
          setAiCoachBootstrap({
            user_ftp: d.user_ftp ?? d.userFtp ?? null,
            is_premium: typeof d.is_premium === "boolean" ? d.is_premium : null,
            is_admin: typeof d.is_admin === "boolean" ? d.is_admin : null,
            credits_remaining: typeof d.credits_remaining === "number" ? d.credits_remaining : d.credits_remaining == null ? null : Number(d.credits_remaining),
            credits_limit: typeof d.credits_limit === "number" ? d.credits_limit : d.credits_limit == null ? null : Number(d.credits_limit),
          });
        } catch { }
      } catch (e) {
        console.error("Failed to load AI coach intro:", e);
        setAiCoachIntroMessage("Sorry, I'm temporarily unavailable. This might be due to high demand or credit limits being reached. Please try again later, upgrade to premium, or create your plan manually.");
      } finally {
        setAiCoachLoading(false);
      }
    })();
  };

  const resumeAiPlanBuilderProgram = (savedState) => {
    const st = savedState && typeof savedState === "object" ? savedState : null;
    setAiBuilderInitialState(st);
    setAiCoachLoading(false);
    setAiCoachIntroMessage(String(st?.intro_message || "").trim() || "Welcome back - let’s continue your plan.");
    try {
      setAiCoachBootstrap((prev) => prev || {
        user_ftp: st?.user_ftp ?? st?.userFtp ?? null,
        is_premium: null,
        is_admin: null,
        credits_remaining: null,
        credits_limit: null,
      });
    } catch { }
    goToAiPlanBuilder();
  };

  // --- Simpl'AI Single Workout Builder page wiring (must come after axiosInstance is defined) ---
  const persistAiSingleBuilderState = React.useCallback(
    (nextState) => {
      // Allow clearing the persisted AI single-session draft (e.g. after save)
      if (nextState == null) {
        try {
          setAiSingleBuilderInitialState(null);
        } catch { }
        // Keep localStorage cache in sync (single-session only; do NOT touch program keys)
        try {
          localStorage.setItem("last_ai_plan_builder_single_cache", JSON.stringify(null));
          localStorage.setItem("has_ongoing_ai_plan_builder_single_cache", JSON.stringify(false));
        } catch { }
        try {
          setOtherUserInfo((prev) => ({
            ...(prev || {}),
            lastAiPlanBuilderSingle: null,
            hasOngoingAiPlanBuilderSingle: false,
          }));
        } catch { }
        return;
      }
      if (typeof nextState !== "object") return;
      try {
        setAiSingleBuilderInitialState(nextState);
      } catch { }
      try {
        const isOngoing = (nextState.status || "in_progress") === "in_progress";
        // Keep localStorage cache in sync (single-session only; do NOT touch program keys)
        try {
          localStorage.setItem("last_ai_plan_builder_single_cache", JSON.stringify(nextState));
          localStorage.setItem("has_ongoing_ai_plan_builder_single_cache", JSON.stringify(Boolean(isOngoing)));
        } catch { }
        setOtherUserInfo((prev) => ({
          ...(prev || {}),
          lastAiPlanBuilderSingle: nextState,
          hasOngoingAiPlanBuilderSingle: Boolean(isOngoing),
        }));
      } catch { }
    },
    [setOtherUserInfo]
  );

  const goToAiSingleSessionBuilder = () => setActiveKey("ai_single_session_builder");

  const openAiSingleSessionBuilder = ({ clearExistingDraft = false } = {}) => {
    setAiSingleIntroMessage("");
    setAiSingleBootstrap(null);
    setAiSingleLoading(true);
    goToAiSingleSessionBuilder();

    (async () => {
      try {
        if (clearExistingDraft) {
          try {
            await axiosInstance.post("/ai/plan_builder/single_session/complete/", {});
          } catch {
            // ignore
          }
          try {
            persistAiSingleBuilderState(null);
          } catch {
            // ignore
          }
        }
        const resp = await axiosInstance.post("/ai/plan_builder/intro_single_session/", {});
        const intro = (resp?.data?.intro_message || "").trim();
        setAiSingleIntroMessage(intro);
        try {
          const d = resp?.data || {};
          setAiSingleBootstrap({
            user_ftp: d.user_ftp ?? d.userFtp ?? null,
            is_premium: typeof d.is_premium === "boolean" ? d.is_premium : null,
            is_admin: typeof d.is_admin === "boolean" ? d.is_admin : null,
            credits_remaining: typeof d.credits_remaining === "number" ? d.credits_remaining : d.credits_remaining == null ? null : Number(d.credits_remaining),
            credits_limit: typeof d.credits_limit === "number" ? d.credits_limit : d.credits_limit == null ? null : Number(d.credits_limit),
          });
        } catch { }
      } catch (e) {
        console.error("Failed to load AI single-session intro:", e);
        setAiSingleIntroMessage("Sorry, I'm temporarily unavailable. This might be due to high demand or credit limits being reached. Please try again later, upgrade to premium, or create your workout manually.");
      } finally {
        setAiSingleLoading(false);
      }
    })();
  };

  const resumeAiSingleSessionBuilder = (savedState) => {
    const st = savedState && typeof savedState === "object" ? savedState : null;
    setAiSingleBuilderInitialState(st);
    setAiSingleLoading(false);
    setAiSingleIntroMessage(String(st?.intro_message || "").trim() || "Welcome back - tell me what you want to do today.");
    try {
      setAiSingleBootstrap((prev) => prev || {
        user_ftp: st?.user_ftp ?? st?.userFtp ?? null,
        is_premium: null,
        is_admin: null,
        credits_remaining: null,
        credits_limit: null,
      });
    } catch { }
    goToAiSingleSessionBuilder();
  };

  const refreshUserInfoAndHistory = async ({
    includeHistory = false,
    validateStrava = false,
    fetchShouldRideOutside = false,
    addLogin = false,
  } = {}) => {
    if (!localStorage.getItem("token")) return;
    const __srGetUserInfoId =
      (window.__srGetUserInfoNextId = (window.__srGetUserInfoNextId || 0) + 1);
    const __srGetUserInfoSource = "App.refreshUserInfoAndHistory";
    try {
      console.log(`[get_user_info] #${__srGetUserInfoId} ${__srGetUserInfoSource} start`, {
        includeHistory,
        validateStrava,
        fetchShouldRideOutside,
      });
      console.trace(`[get_user_info] trace #${__srGetUserInfoId} ${__srGetUserInfoSource}`);
    } catch { }
    setIsRefreshingHistory(true);
    try {
      try { window.__srUserInfoFetchInFlight = true; } catch { }
      let clientIp = null;
      try {
        if (fetchShouldRideOutside) {
          const today = new Date().toISOString().slice(0, 10);
          const storedDate = localStorage.getItem("rideOutsideModalLastShownDate");
          let shownToday = storedDate === today;
          if (!shownToday) {
            const legacyTs = Number(localStorage.getItem("rideOutsideModalLastShownAt") || "0");
            if (legacyTs) {
              const legacyDate = new Date(legacyTs).toISOString().slice(0, 10);
              shownToday = legacyDate === today;
            }
          }
          if (!shownToday && !rideOutsideProposed.fetched) {
            const ipResponse = await fetch("https://api64.ipify.org?format=json");
            const ipData = await ipResponse.json();
            clientIp = ipData.ip;
            setRideOutsideProposed(prev => ({ ...prev, fetched: true }));
          }
        }
      } catch (e) {
        // ignore storage errors
      }
      const resp = await axiosInstance.post("/get_user_info/", {
        fetchShouldRideOutside: clientIp,
        // Validate Strava on app startup (treat invalid token as not synced)
        validateStrava: !!validateStrava,
        exclude_history: !includeHistory,
        add_login: !!addLogin,
        debug_source: `${__srGetUserInfoSource}#${__srGetUserInfoId}`,
      });
      if (resp?.data?.refresh_token) {
        try {
          localStorage.setItem("token", resp.data.access_token);
          localStorage.setItem("refresh_token", resp.data.refresh_token);
        } catch { }
      }
      if (resp?.data) {
        // Always hydrate AI draft local cache from canonical backend state (Firestore)
        try { syncAiDraftCacheFromUserInfo(resp.data); } catch { }
        try { setUsername(resp.data.username); } catch { }
        try {
          // Only overwrite history when we explicitly requested it.
          // This prevents "light" refreshes (exclude_history=true) from clearing already-loaded history.
          if (includeHistory) setHistory(resp.data.history || []);
        } catch { }
        try {
          setProgressCount(resp.data.progress_count);
        } catch { }
        try { setIsAdmin(resp.data.is_admin); } catch { }
        try { setIsPremium(Boolean(resp.data.is_premium)); } catch { }
        try { setIsBetaTester(Boolean(resp.data.is_beta_tester)); } catch { }
        try { setFTP(resp.data.ftp || FTP); } catch { }
        try { setWeight(resp.data.weight || weight); } catch { }
        try { setFavouritePlans(resp.data.favourite || []); } catch { }
        try {
          setOtherUserInfo(prevInfo => ({
            ...prevInfo,
            stravaRefreshToken: resp.data.strava_refresh_token || prevInfo?.stravaRefreshToken || null,
            // Used for onboarding tours / first-time UX (safe mapping from backend fields)
            loginCount: (() => {
              const raw =
                resp.data?.login_count ??
                resp.data?.loginCount ??
                resp.data?.other_info?.login_count ??
                resp.data?.other_info?.loginCount ??
                null;
              if (raw === null || raw === undefined) return prevInfo?.loginCount ?? null;
              const n = Number(raw);
              return Number.isFinite(n) ? n : (prevInfo?.loginCount ?? null);
            })(),
            shouldRideOutside: resp.data.other_info?.should_ride_outside ?? prevInfo?.shouldRideOutside,
            last_login: resp.data.other_info?.last_login_ts ?? prevInfo?.last_login,
            email: resp.data.email || resp.data.other_info?.email || prevInfo?.email || null,
            bgUrl: resp.data.other_info?.bg_url || prevInfo?.bgUrl || null,
            bgUrlPath: resp.data.other_info?.bg_url_path || prevInfo?.bgUrlPath || null,
            lastAiPlanBuilder: resp.data.last_ai_plan_builder || null,
            hasOngoingAiPlanBuilder: Boolean(resp.data.has_ongoing_ai_plan_builder),
            lastAiPlanBuilderSingle: resp.data.last_ai_plan_builder_single || null,
            hasOngoingAiPlanBuilderSingle: Boolean(resp.data.has_ongoing_ai_plan_builder_single),
          }));
        } catch { }
      }
    } catch (e) {
      console.error("Error refreshing user info/history", e);
    } finally {
      try {
        window.__srUserInfoFetchInFlight = false;
        window.__srUserInfoBootstrapped = true;
      } catch { }
      setIsRefreshingHistory(false);
    }
  };

  // On app startup, if a token exists, refresh user info once so Firestore-backed drafts
  // can be restored even when localStorage is empty (new tab/device).
  useEffect(() => {
    // React 18 StrictMode (dev) intentionally mounts/unmounts/remounts, which can double-run this effect.
    // Use a global guard so we only bootstrap user info once per page load.
    try {
      if (window.__srInitialUserInfoRefreshRan) return;
      window.__srInitialUserInfoRefreshRan = true;
    } catch { }
    try {
      const tok = localStorage.getItem("token");
      if (!tok) return;
    } catch {
      return;
    }
    setIsBootstrappingUserInfo(true);
    refreshUserInfoAndHistory({ includeHistory: false, validateStrava: true, fetchShouldRideOutside: true })
      .finally(() => setIsBootstrappingUserInfo(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle response errors Logic needs to be updated in SaveTraining.js as well +  Logic needs to be updated in SaveTraining.js as well + Login + App.js
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      // Check if the error is due to an expired access token
      if (
        error.response &&
        error.response.status === 401 &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true; // Prevent infinite retries

        try {
          // Call /refresh/token to get new tokens
          const refreshToken = localStorage.getItem("refresh_token");
          const refreshResponse = await axios.post("api/refresh_tokens/", {
            refresh_token: refreshToken,
          });

          if (refreshResponse.status === 200) {
            const { access_token: newToken, refresh_token: newRefreshToken } =
              refreshResponse.data;

            // Store new tokens in localStorage
            localStorage.setItem("token", newToken);
            localStorage.setItem("refresh_token", newRefreshToken);

            // Update Authorization header and retry the original request
            originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
            return axiosInstance(originalRequest);
          }
        } catch (refreshError) {
          alertDlg("You’ve been inactive for too long. You will now be logged out.");
          console.error("Failed to refresh token:", refreshError);
          localStorage.removeItem("token"); // Remove the stored token
          localStorage.removeItem("refresh_token"); // Remove the stored token
          setUsername(null);
          console.log("Logged out");
          // Optionally, handle token refresh failure (e.g., logout user)
        }
      }

      return Promise.reject(error);
    }
  );

  // Dev-only feedback modals (uses the SAME axios instance + token refresh interceptors)
  const devFeedback = useDevFeedback({
    userLoaded: Boolean(username),
    username,
    isBetaTester,
    attentionItems: DEV_FEEDBACK_ATTENTION_ITEMS,
    axiosInstance,
    alertDlg,
    suppress: suppressGlobalModals,
  });

  const calculateTSS = () => {
    if (!FTP || FTP <= 0 || steps.length === 0) {
      setPlanStressPoints(Math.round(0))
    }
    let totalDuration = 0;
    let intensityFactorSum = 0;

    steps.forEach(step => {
      const { duration, watt } = step;
      if (duration && watt) {
        const intensityFactor = watt / FTP; // Relative intensity
        intensityFactorSum += intensityFactor ** 2 * duration; // Weighted by time
        totalDuration += duration;
      }
    });

    if (totalDuration === 0) {
      return 0; // No training time, no TSS
    }

    const normalizedPower = Math.sqrt(intensityFactorSum / totalDuration) * FTP; // Approximated NP
    const tss = (totalDuration * normalizedPower ** 2) / (FTP ** 2 * 3600) * 100;

    setPlanStressPoints(Math.round(tss)); // Return the TSS rounded to the nearest whole number
  }


  const getAllTrainingPlansInfo = ({ uuid, username_to_fetch } = {}) => {
    setArePlansLoading(true);
    axiosInstance
      .post("/get_all_training_plans/", {
        username_to_fetch: username_to_fetch !== undefined ? username_to_fetch : usernameToFetch,
        exclude_steps: true,
        limit: 10000,
      })
      .then((response) => {
        if (response.data.refresh_token) {
          localStorage.setItem("token", response.data.access_token);
          localStorage.setItem("refresh_token", response.data.refresh_token);
        }
        console.log("plans length", response.data.plans_info.length);
        const newPlansInfo = response.data.plans_info.map((x) => ({
          ...x,
          display_name:
            favouritePlans &&
              favouritePlans.includes(x.uuid) &&
              !x.display_name.includes("❤")
              ? "❤ - " + x.display_name
              : x.display_name,
        }));
        setPlansInfo(newPlansInfo);
        selectPlan(uuid, newPlansInfo);
      })
      .catch((error) =>
        console.error("Error retrieving training plans:", error)
      )
      .finally(() => setArePlansLoading(false));
  };

  // Display-only helper: resolve any plan uuid to a human label (used for showing external `previous_uuid` nicely)
  const getPlanLabelByUuid = async (uuid) => {
    const u = uuid === null || uuid === undefined ? "" : String(uuid).trim();
    if (!u || u == "1") return null;
    try {
      const resp = await axiosInstance.post("/get_plan_label/", { uuid: u });
      return resp?.data?.label || null;
    } catch (e) {
      return null;
    }
  };

  const setFavourite = ({ favourite }) => {
    if (
      favourite &&
      (isModificationMade ||
        (planName && planName != selectedPlan.name) ||
        (planDescription && planDescription != selectedPlan.description) ||
        (planCategory && planCategory != selectedPlan.category))
    ) {
      alertDlg("You are trying to save as favourite a plan under creation or modification. Please save it first.");
    } else {
      selectedPlan &&
        selectedPlan.uuid &&
        selectedPlan.uuid != "1" &&
        axiosInstance
          .post("/favourite/", {
            favourite: favourite,
            plan_uuid: selectedPlan.uuid,
          })
          .then((response) => {
            setPlanIsFavourite(favourite);
            setFavouritePlans(response.data.favourite || []);
          })
          .catch((error) => alertDlg("Error changing favourite status."));
    }
  };

  const saveTrainingPlan = async () => {
    const trainingData = {
      steps: steps,
      ref_ftp: FTP,
      name: planName,
      description: planDescription,
      category: planCategory,
      stress_points: planStressPoints,
      previous_uuid: previousUuid || null,
    };
    const exists =
      plansInfo.filter(
        (x) =>
          x.username == username &&
          x.name == planName &&
          x.category == planCategory
      ).length != 0;
    const proceed =
      !exists ||
      (await confirm(
        `One of your plan is already name as '${planName}', do you want to overwrite it ?`
      ));
    if (!proceed) return;
    try {
      const response = await axiosInstance.post("/save_training_plan/", trainingData);
      setPlanSavedModalOpen(true);
      getAllTrainingPlansInfo({ uuid: response.data.uuid });
    } catch (error) {
      alertDlg("Error saving training");
    }
  };

  // feedback submission handled inside FeedbackBugReports component

  const showModal = (value) => {
    setIsModalOpen(value);
  };

  const handleOk = async () => {
    if (isModalOpen === "create") {
      await selectPlan(-1, plansInfo);
      setShowTrainingForm(true);
      setIsModalOpen(false);
      return;
    }
    // If `isModalOpen` is a uuid, confirm switching plans (lazy-load steps).
    await selectPlan(isModalOpen, plansInfo);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // feedback modal handlers managed in FeedbackBugReports

  useEffect(() => {
    if (username) {
      getAllTrainingPlansInfo({ uuid: "1" });
      setRefFTPForAdjust(FTP);
    }
  }, [username]);

  // Next-session suggestion modal: once plans are loaded, propose selecting the chained plan UUID (unless dismissed)
  useEffect(() => {
    const nsUuid =
      nextSessionUuid === null || nextSessionUuid === undefined
        ? null
        : String(nextSessionUuid);
    if (!username || !nsUuid || nsUuid === "1") return;
    if (!Array.isArray(plansInfo) || plansInfo.length === 0) return;

    let dismissedUuid = null;
    let discardedUuid = null;
    try {
      dismissedUuid = localStorage.getItem("next_session_uuid");
      discardedUuid = localStorage.getItem("discard_uuid");
    } catch (e) {
      // ignore storage errors
    }
    if (dismissedUuid === nsUuid || discardedUuid === nsUuid) return;

    if (nextSessionPromptShownUuidRef.current === nsUuid) return;

    const plan = plansInfo.find((p) => String(p.uuid) === nsUuid);
    if (!plan) return;

    nextSessionPromptShownUuidRef.current = nsUuid;
    setNextSessionPromptPlan(plan);
  }, [username, plansInfo, nextSessionUuid]);

  useEffect(() => {
    calculateTSS()
  }, [steps, FTP]);


  useEffect(() => {
    setPlansInfo(
      plansInfo.map((x) => ({
        ...x,
        display_name:
          favouritePlans &&
            favouritePlans.includes(x.uuid) &&
            !x.display_name.includes("❤")
            ? "❤ - " + x.display_name
            : x.display_name &&
              (!favouritePlans || !favouritePlans.includes(x.uuid)) &&
              x.display_name.includes("❤ - ")
              ? x.display_name.slice(4)
              : x.display_name,
      }))
    );
  }, [planIsFavourite]);

  const createWarmUpSteps = (duration, fromWatt, toWatt, comment) => {
    const minStepDuration = 10;
    const newSteps = [];
    if (!duration || !fromWatt || !toWatt || duration < minStepDuration * 2) {
      alertDlg(`Duration (>=${minStepDuration * 2} secs) and average watts are required!`);
      return;
    }

    const toWattInt = parseInt(toWatt);
    const fromWattInt = parseInt(fromWatt);
    const idealWattStep = Math.max(Math.round(FTP / 100), 1) * 5;
    const up = toWattInt - fromWattInt > 0;
    const stepWatt =
      duration / Math.abs(toWattInt - fromWattInt) >=
        minStepDuration / idealWattStep
        ? idealWattStep
        : Math.ceil(
          (minStepDuration * Math.abs(toWattInt - fromWattInt)) / duration
        );
    const stepDuration = Math.ceil(
      duration / (Math.abs(toWattInt - fromWattInt) / stepWatt)
    );
    let totalUsedDuration = 0;
    for (
      let i = fromWattInt;
      (up && i < toWattInt) || (!up && i > toWattInt);
      i = up ? i + stepWatt : i - stepWatt
    ) {
      if (
        (up && i + stepWatt < toWattInt) ||
        (!up && i - stepWatt > toWattInt)
      ) {
        newSteps.push({
          duration: stepDuration,
          watt: i,
          comment: comment,
          selected: false,
        });
        totalUsedDuration += stepDuration;
      } else {
        newSteps.push({
          duration: duration - totalUsedDuration,
          watt: toWattInt,
          comment: comment,
          selected: false,
        });
        i = toWattInt;
      }
    }
    return newSteps;
  };
  const onAdjustPower = async ({ nextFtp, skipSave = false } = {}) => {
    const MIN_FTP = 20;
    const raw =
      typeof nextFtp === "number" && Number.isFinite(nextFtp) ? nextFtp : FTP;
    let targetFtp = Number(raw);
    if (!Number.isFinite(targetFtp) || targetFtp <= 0) targetFtp = MIN_FTP;
    // Clamp to minimum FTP at apply-time (Enter / 2s idle)
    targetFtp = Math.max(MIN_FTP, Math.round(targetFtp));

    // Keep the input in sync if we're adjusting to a suggested value.
    try {
      if (targetFtp !== FTP) setFTP(targetFtp);
    } catch { }

    const ref = Number(refFTPForAdjust);
    const canRescaleSteps = Number.isFinite(ref) && ref > 0 && Array.isArray(steps) && steps.length > 0;

    // If we have steps + a valid reference FTP, rescale steps.
    if (canRescaleSteps) {
      const newSteps = steps.map((s) => {
        const comment = String(s?.comment || "");
        return {
          ...s,
          watt:
            selectedPlan.username == "Test" &&
              selectedPlan.name == "Ramp Up" &&
              comment.includes("lap")
              ? s.watt
              : Math.round((s.watt * targetFtp) / ref),
        };
      });
      setSteps(newSteps);
    }

    // Always mark the current FTP as the latest reference (even if there are no steps yet).
    setRefFTPForAdjust(targetFtp);

    // Remember last non-100 FTP value
    if (targetFtp !== 100) {
      setLastNon100FTP(targetFtp);
    }

    // Save FTP to backend (only when user is actually logged in, and only for explicit commits)
    if (!skipSave) {
      let hasToken = false;
      try {
        hasToken = Boolean(localStorage.getItem("token"));
      } catch { }
      if (hasToken) {
        try {
          await axiosInstance.post("/update_profile/", {
            ftp: targetFtp,
          });
        } catch (error) {
          // Silently fail - FTP adjustment still works locally
          console.warn("Failed to save FTP to backend:", error);
        }
      }
    }
  };

  // Auto-adjust workout steps when user changes FTP:
  // - Debounced (2s after last change)
  // - Also supports immediate trigger via Enter key in inputs (calls onAdjustPower directly)
  const ftpAutoAdjustTimerRef = useRef(null);
  useEffect(() => {
    try {
      if (ftpAutoAdjustTimerRef.current) {
        clearTimeout(ftpAutoAdjustTimerRef.current);
        ftpAutoAdjustTimerRef.current = null;
      }
    } catch { }

    const MIN_FTP = 20;
    const ftpNumRaw = Number(FTP);
    // Do not auto-adjust if FTP isn't a real value yet (e.g. blank input, not logged in).
    if (!Number.isFinite(ftpNumRaw) || ftpNumRaw <= 0) return;

    // Only auto-adjust when we actually have a loaded workout to rescale.
    if (!Array.isArray(steps) || steps.length === 0) return;

    // Don't auto-adjust (or attempt backend calls) when there's no auth token (e.g. login/landing pages).
    let hasToken = false;
    try {
      hasToken = Boolean(localStorage.getItem("token"));
    } catch { }
    if (!hasToken) return;

    const ftpNum = ftpNumRaw;
    const clamped = Math.max(MIN_FTP, Math.round(ftpNum));

    const refNum = Number(refFTPForAdjust);
    // If we don't have a valid reference FTP to rescale from, do nothing.
    if (!Number.isFinite(refNum) || refNum <= 0) return;
    if (Number.isFinite(refNum) && refNum > 0 && clamped === refNum) return;

    ftpAutoAdjustTimerRef.current = setTimeout(() => {
      try {
        // Auto-rescale should not spam /update_profile/
        onAdjustPower({ nextFtp: clamped, skipSave: true });
      } catch { }
    }, 2000);

    return () => {
      try {
        if (ftpAutoAdjustTimerRef.current) {
          clearTimeout(ftpAutoAdjustTimerRef.current);
          ftpAutoAdjustTimerRef.current = null;
        }
      } catch { }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FTP, refFTPForAdjust, steps]);

  const openTrainingForm = () => setShowTrainingForm(true);
  const goToLetsRide = () => setActiveKey(isMobile ? "3" : "2");
  const goToPlanSetup = () => setActiveKey(isMobile ? "3" : "1");
  const leaveAiPlanBuilder = () => goToPlanSetup();
  const leaveAiSingleSessionBuilder = () => goToPlanSetup();

  const addStep = (newSteps) => {
    //legacy

    setSteps([...steps, ...newSteps.map((x) => ({ ...x, selected: false }))]);
  };

  const toggleSelectStep = (index) => {
    const newSteps = steps.map((step, i) =>
      index.includes(i) ? { ...step, selected: !step.selected } : step
    );
    setSteps(newSteps);
  };

  const duplicateSelectedSteps = () => {
    const newSteps = [...steps];
    steps.forEach((step) => {
      if (step.selected) {
        newSteps.push({ ...step, selected: false });
      }
    });
    setSteps(newSteps);
    setIsModificationMade(true);
  };

  const reorderSteps = ({ sourceIndices, destinationIndex }) => {
    if (!Array.isArray(sourceIndices)) return;
    const unique = Array.from(new Set(sourceIndices))
      .filter((i) => Number.isInteger(i) && i >= 0 && i < steps.length)
      .sort((a, b) => a - b);
    if (unique.length === 0) return;
    const moving = unique.map((i) => steps[i]);
    const remaining = steps.filter((_, idx) => !unique.includes(idx));
    const dest = Math.max(0, Math.min(destinationIndex, remaining.length));
    const newSteps = [
      ...remaining.slice(0, dest),
      ...moving,
      ...remaining.slice(dest),
    ];
    setSteps(newSteps);
    setIsModificationMade(true);
  };

  const deleteSelectedSteps = () => {
    const newSteps = steps.filter((step) => !step.selected);
    setSteps(newSteps);
    setIsModificationMade(true);
  };

  const handlePlanNameChange = (e) => {
    const value = e.target.value;
    setPlanName(value);
  };

  const selectPlanRequestIdRef = useRef(0);
  const normalizeUuid = (v) => {
    if (v === null || v === undefined) return "";
    return String(v).trim();
  };
  const isRealPlanUuid = (v) => {
    const s = normalizeUuid(v);
    // eslint-disable-next-line eqeqeq
    return Boolean(s && s != "1" && s != "-1");
  };
  const fetchPlanInfoByUuid = async (uuid) => {
    const u = normalizeUuid(uuid);
    // eslint-disable-next-line eqeqeq
    if (!u || u == "1") return null;
    const resp = await axiosInstance.post("/get_training_plan_by_uuid/", { uuid: u });
    return resp?.data?.plan_info || null;
  };

  const selectPlan = async (uuid, plansInfoArg) => {
    const u = normalizeUuid(uuid);
    const list = Array.isArray(plansInfoArg) ? plansInfoArg : plansInfo;

    // Reset / create mode
    if (!isRealPlanUuid(u)) {
      // eslint-disable-next-line eqeqeq
      if (u != normalizeUuid(selectedPlan.uuid) || u === "-1") {
        setIsSelectingPlan(false);
        setSelectedPlan({ uuid: 1 });
        setSteps([]);
        setIsModificationMade(false);
        setPlanName(null);
        setPlanStressPoints(0);
        setPlanDescription(null);
        setPlanIsFavourite(false);
        setPlanCategory(null);
        setPreviousUuid(null);
      }
      return;
    }

    const planStub =
      (list || []).find((plan) => normalizeUuid(plan?.uuid) === u) || null;
    if (!planStub) return;

    // Always lazy-load steps from backend when selecting a plan.
    setIsSelectingPlan(true);
    const reqId = (selectPlanRequestIdRef.current || 0) + 1;
    selectPlanRequestIdRef.current = reqId;

    let planFull = null;
    try {
      planFull = await fetchPlanInfoByUuid(u);
    } catch (e) {
      console.warn("Failed to fetch plan steps:", e);
      planFull = null;
    }

    // If another selection happened while we were fetching, ignore this response.
    if (selectPlanRequestIdRef.current !== reqId) return;

    const mergedPlan = planFull ? { ...planStub, ...planFull } : { ...planStub };
    const rawSteps = Array.isArray(mergedPlan.steps) ? mergedPlan.steps : [];

    // Patch only the selected plan inside plansInfo (do not overwrite the full list)
    if (rawSteps.length > 0) {
      setPlansInfo((prev) =>
        (prev || []).map((p) =>
          normalizeUuid(p?.uuid) === u ? { ...p, steps: rawSteps } : p
        )
      );
    }

    const newSteps = [];
    [...rawSteps]
      .sort((a, b) => (Number(a?.order) || 0) - (Number(b?.order) || 0))
      .forEach((step) => {
        if (!step) return;
        const additionalComment =
          step.power == 0
            ? "Free ride ! Feel free to manually adjust your ERG."
            : step.power == 1000
              ? "Best effort ! Feel free to manually adjust your ERG."
              : null;
        const stepPower =
          step.power == 0
            ? mergedPlan.ref_ftp * 0.6
            : step.power == 1000
              ? mergedPlan.ref_ftp * 1.01
              : step.power;
        const stepMode = resolveStepMode(step.power);
        let stepComment =
          !step.comment && additionalComment ? additionalComment : step.comment;
        stepComment =
          stepComment && step.rpm
            ? `@ ${step.rpm} rpm ` + stepComment
            : step.rpm
              ? `@ ${step.rpm} rpm`
              : stepComment;
        if (!step.power_to) {
          newSteps.push({
            watt:
              mergedPlan.username == "Test" &&
                mergedPlan.name == "Ramp Up" &&
                stepPower >= 100
                ? stepPower
                : Math.round((stepPower / mergedPlan.ref_ftp) * FTP),
            duration: step.duration_sec,
            comment: stepComment,
            selected: false,
            mode: stepMode,
          });
        } else {
          const warmUpSteps = createWarmUpSteps(
            step.duration_sec,
            Math.round((stepPower / mergedPlan.ref_ftp) * FTP),
            Math.round((step.power_to / mergedPlan.ref_ftp) * FTP),
            stepComment
          );
          newSteps.push(...warmUpSteps.map((s) => ({ ...s, mode: STEP_MODE.ERG })));
        }
      });

    // If we couldn't load steps, keep selection but prevent accidental empty ride.
    if (rawSteps.length === 0) {
      alertDlg("Could not load this plan's steps. Please try again.");
    }

    setSteps(newSteps);
    setSelectedPlan(mergedPlan);
    setPlanDescription(mergedPlan.description);
    setPlanCategory(mergedPlan.category);
    setPreviousUuid(mergedPlan.previous_uuid || null);
    setRefFTPForAdjust(FTP);
    setIsModificationMade(false);
    setPlanName(mergedPlan.name);
    setPlanIsFavourite(favouritePlans.includes(mergedPlan.uuid));
    setPlanStressPoints(mergedPlan.stress_points || 0);
    setIsSelectingPlan(false);
  };

  const config = {
    title: "Use Hook!",
    content: "test",
  };
  const title = "SimplyRide.app";
  const slogan = "Plan, train, share.";

  // Session-aware suppression of plan-change warning, preference stored in localStorage
  const ensureSessionId = () => {
    let id = sessionStorage.getItem("appSessionId");
    if (!id) {
      id = `${Date.now()}_${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem("appSessionId", id);
    }
    return id;
  };
  const isPlanChangeWarningSuppressed = () => {
    const currentSessionId = ensureSessionId();
    const storedSessionId = localStorage.getItem("hidePlanChangeWarningForSession");
    return storedSessionId === currentSessionId;
  };

  const openPremiumRequest = () => {
    const template = "Hi Sam, I'd like to unlock premium features. Could you let me know how to proceed?";
    setFeedbackMode("feedback");
    setFeedbackInitialText(template);
    setIsFeedbackOpen(true);
  };

  const onMenuSelect = (key) => {
    console.log("onMenuSelect called with key:", key);
    // Handle control items (bottom of sidebar)
    if (String(key).startsWith("control_")) {
      if (key === "control_profile") {
        setActiveKey("profile");
      } else if (key === "control_mute") {
        setIsMute((m) => !m);
      } else if (key === "control_feedback") {
        setFeedbackMode("feedback");
        setFeedbackInitialText("");
        setIsFeedbackOpen(true);
      } else if (key === "control_bug") {
        setFeedbackMode("bug");
        setFeedbackInitialText("");
        setIsFeedbackOpen(true);
      } else if (key === "control_logout") {
        console.log("Logout button clicked!");
        handleLogout();
      } else if (key === "control_expand") {
        setSiderCollapsed(false);
      }
      return;
    }
    // Handle footer link items (legacy keys kept for safety; new combined contact handled in Sidebar modal)
    if (key == "1" && steps.length > 0) {
      if (!isPlanChangeWarningSuppressed()) {
        setSuppressPlanChangeThisSession(false);
        setPlanChangeWarningOpen(true);
      }
    }
    if (key == "4") {
      setReloadTs(Date.now());
    }
    setActiveKey(key);
    // Lazy-load history only when needed (History + Data Analysis)
    if (key === "4" || key === "5") {
      // fire-and-forget; UI shows loading state in History table / Data Analysis wrapper
      refreshUserInfoAndHistory({ includeHistory: true, validateStrava: false, fetchShouldRideOutside: false });
    }
  };

  const openAdminUserHistory = (targetUsername) => {
    try {
      if (typeof targetUsername === "string" && targetUsername.trim()) {
        setAdminUserHistoryUsername(targetUsername);
        setActiveKey("admin_user_history");
      }
    } catch { }
  };

  const backToAdminDashboard = () => {
    setActiveKey("6");
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    setUsername(null);
    setIsPremium(false);
    setIsAdmin(false);
    setIsBetaTester(false);
    try {
      delete window.__srInitialUserInfoRefreshRan;
      delete window.__srUserInfoBootstrapped;
      delete window.__srUserInfoFetchInFlight;
    } catch { }
  };

  if (username) {
    return (
      <InstallProvider>
        <Layout className="app-layout" style={{ height: "100vh", overflow: "hidden" }}>
          <Sidebar
            isMobile={isMobile}
            siderCollapsed={siderCollapsed}
            setSiderCollapsed={setSiderCollapsed}
            activeKey={activeKey}
            onMenuSelect={onMenuSelect}
            FTP={FTP}
            isMute={isMute}
            backendBaseUrl={backendBaseUrl}
            title={title}
            slogan={slogan}
            logo={logo}
            username={username}
            isAdmin={isAdmin}
            isPremium={isPremium}
          />
          <Layout style={{ display: "flex", flexDirection: "column", height: "100vh", minHeight: 0 }}>
            <Content className="app-content" style={{ flex: "1 1 0%", minHeight: 0, overflow: "auto" }}>
              <div>
                <div
                  style={{ margin: "0 12px", padding: "0px", display: isLandscape ? true : "none" }}
                  className="content"
                >
                  <Modal
                    title="You Should Go Ride Outside! 🚴‍♂️☀️"
                    open={!suppressGlobalModals && otherUserInfo.shouldRideOutside > 90 && !rideOutsideProposed.shown} // Show modal only if sunny (otherwise backend return 0) and 1h30 left before sunset
                    rootClassName="liquid-glass-modal"
                    onCancel={() => {
                      try {
                        const today = new Date().toISOString().slice(0, 10);
                        localStorage.setItem("rideOutsideModalLastShownDate", today);
                        localStorage.removeItem("rideOutsideModalLastShownAt");
                      } catch (e) {
                        // ignore storage errors
                      }
                      setRideOutsideProposed({ fetched: true, shown: true });
                    }} // Close modal if user decides to ignore
                    footer={[
                      <Button
                        key="indoor"
                        type="primary"
                        className="primary-glass-btn"
                        onClick={() => {
                          try {
                            const today = new Date().toISOString().slice(0, 10);
                            localStorage.setItem("rideOutsideModalLastShownDate", today);
                            localStorage.removeItem("rideOutsideModalLastShownAt");
                          } catch (e) {
                            // ignore storage errors
                          }
                          setRideOutsideProposed({ fetched: true, shown: true });
                        }}
                      >
                        SimplyRide Anyway 😉
                      </Button>,
                    ]}
                  >
                    <p>
                      It looks like the weather is good and the wind is calm ! 🌞 <br />
                      You have <strong>
                        {Math.floor(otherUserInfo.shouldRideOutside / 60)}h {otherUserInfo.shouldRideOutside % 60}min
                      </strong> before sunset. 🌇
                    </p>
                  </Modal>

                  <Modal
                    title="Next session ready"
                    open={Boolean(nextSessionPromptPlan)}
                    rootClassName="liquid-glass-modal"
                    onCancel={() => {
                      try {
                        const nsUuid = nextSessionPromptPlan?.uuid;
                        if (nsUuid !== undefined && nsUuid !== null) {
                          localStorage.setItem("discard_uuid", String(nsUuid));
                          localStorage.setItem("next_session_uuid", String(nsUuid));
                        }
                      } catch (e) {
                        // ignore storage errors
                      }
                      setNextSessionPromptPlan(null);
                    }}
                    footer={[
                      <Button
                        key="ride"
                        type="primary"
                        className="primary-glass-btn"
                        onClick={async () => {
                          if (nextSessionPromptPlan?.uuid) {
                            await selectPlan(nextSessionPromptPlan.uuid, plansInfo);
                          }
                          goToLetsRide();
                          setNextSessionPromptPlan(null);
                        }}
                      >
                        SimplyRide
                      </Button>,
                      <Button
                        key="see"
                        onClick={async () => {
                          if (nextSessionPromptPlan?.uuid) {
                            await selectPlan(nextSessionPromptPlan.uuid, plansInfo);
                          }
                          goToPlanSetup();
                          setNextSessionPromptPlan(null);
                        }}
                      >
                        See plan / adjust FTP
                      </Button>,
                      <Button
                        key="discard"
                        danger
                        onClick={() => {
                          try {
                            const nsUuid = nextSessionPromptPlan?.uuid;
                            if (nsUuid !== undefined && nsUuid !== null) {
                              localStorage.setItem("discard_uuid", String(nsUuid));
                              localStorage.setItem("next_session_uuid", String(nsUuid));
                            }
                          } catch (e) {
                            // ignore storage errors
                          }
                          setNextSessionPromptPlan(null);
                        }}
                      >
                        Discard
                      </Button>,
                    ]}
                  >
                    <p style={{ marginBottom: 0 }}>
                      We found your next session:
                      <br />
                      <strong>{nextSessionPromptPlan?.display_name || nextSessionPromptPlan?.name}</strong>
                    </p>
                  </Modal>

                  {/* Auto-open update notice for v2.0 (gated by last_login_ts and localStorage) */}
                  <UpdateMessageModal
                    otherInfo={otherUserInfo}
                  />

                  {/* Plan switch confirmation (used when user has unsaved modifications and picks another plan) */}
                  <Modal
                    title="Unsaved changes"
                    open={Boolean(isModalOpen)}
                    rootClassName="liquid-glass-modal"
                    onCancel={handleCancel}
                    footer={[
                      <Button key="cancel" onClick={handleCancel}>
                        Cancel
                      </Button>,
                      isModalOpen === "create" ? (
                        <Button
                          key="info"
                          title="New here? Show me a tour"
                          aria-label="New here? Show me a tour"
                          onClick={() => {
                            // Close the confirmation modal first so the tour can target elements behind it.
                            handleCancel();
                            try {
                              setTimeout(() => {
                                try {
                                  window.dispatchEvent(new Event("sr_plan_setup_start_tour"));
                                } catch { }
                              }, 0);
                            } catch { }
                          }}
                        >
                          <InfoCircleOutlined />
                        </Button>
                      ) : null,
                      <Button
                        key="ok"
                        type="primary"
                        className="primary-glass-btn"
                        onClick={handleOk}
                        loading={isSelectingPlan}
                      >
                        {isModalOpen === "create" ? "Create new plan" : "Switch plan"}
                      </Button>,
                    ]}
                  >
                    <p style={{ marginBottom: 0 }}>
                      You have unsaved changes. Do you want to discard them and{" "}
                      {isModalOpen === "create" ? "create a new plan" : "switch plans"}?
                    </p>
                  </Modal>


                  <Modal
                    title="Plan saved"
                    open={planSavedModalOpen}
                    rootClassName="liquid-glass-modal"
                    onCancel={() => setPlanSavedModalOpen(false)}
                    footer={[
                      <Button
                        key="ok"
                        type="primary"
                        className="primary-glass-btn"
                        onClick={() => setPlanSavedModalOpen(false)}
                      >
                        OK
                      </Button>,
                    ]}
                  >
                    <p>Training plan well saved, reloading... (wait a few seconds..)</p>
                  </Modal>



                  <FeedbackBugReports
                    open={isFeedbackOpen}
                    mode={feedbackMode}
                    onClose={() => {
                      setIsFeedbackOpen(false);
                      setFeedbackInitialText("");
                    }}
                    axiosInstance={axiosInstance}
                    alertDlg={alertDlg}
                    initialScreenshot={initialBugScreenshot}
                    initialText={feedbackInitialText}
                  />
                  {!suppressGlobalModals ? devFeedback?.modals : null}
                  {/* Floating Bug Report Button - bottom right, beside Demo and Donate */}
                  <Tooltip title="Report a bug">
                    <div
                      id="tour-report-bug"
                      onClick={() => {
                        setFeedbackMode("bug");
                        setFeedbackInitialText("");
                        setIsFeedbackOpen(true);
                        setInitialBugScreenshot(null);
                      }}
                      onMouseEnter={() => setIsBugButtonHovered(true)}
                      onMouseLeave={() => setIsBugButtonHovered(false)}
                      style={{
                        position: "fixed",
                        bottom: "20px",
                        right: "180px",
                        backgroundColor: "#ffe6e6",
                        color: "#333",
                        width: isBugButtonHovered ? "66px" : "60px",
                        height: isBugButtonHovered ? "66px" : "60px",
                        borderRadius: "50%",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        cursor: "pointer",
                        zIndex: 10000001,
                        fontSize: isBugButtonHovered ? "28px" : "24px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "all 0.2s ease",
                      }}
                    >
                      <BugOutlined />
                    </div>
                  </Tooltip>
                  {!isMobile && activeKey === "1" && (
                    <>
                      <PlanSetup
                        // actions
                        saveTrainingPlan={saveTrainingPlan}
                        getAllTrainingPlansInfo={getAllTrainingPlansInfo}
                        getPlanLabelByUuid={getPlanLabelByUuid}
                        showModal={showModal}
                        handleOk={handleOk}
                        handleCancel={handleCancel}
                        selectPlan={selectPlan}
                        setFavourite={setFavourite}
                        onAdjustPower={onAdjustPower}
                        onShowTrainingForm={openTrainingForm}
                        goToLetsRide={goToLetsRide}
                        showTrainingForm={showTrainingForm}
                        // state + setters
                        FTP={FTP}
                        setFTP={setFTP}
                        steps={steps}
                        planName={planName}
                        handlePlanNameChange={handlePlanNameChange}
                        planCategory={planCategory}
                        setPlanCategory={setPlanCategory}
                        planDescription={setPlanDescription ? planDescription : planDescription}
                        setPlanDescription={setPlanDescription}
                        setPlanName={setPlanName}
                        setSteps={setSteps}
                        previousUuid={previousUuid}
                        setPreviousUuid={setPreviousUuid}
                        createWarmUpSteps={createWarmUpSteps}
                        isMobile={isMobile}
                        setUsernameToFetch={setUsernameToFetch}
                        isModificationMade={isModificationMade}
                        selectedPlan={selectedPlan}
                        plansInfo={plansInfo}
                        username={username}
                        isSelectingPlan={isSelectingPlan}
                        isPremium={isPremium}
                        lastAiPlanBuilder={otherUserInfo?.lastAiPlanBuilder}
                        hasOngoingAiPlanBuilder={otherUserInfo?.hasOngoingAiPlanBuilder}
                        lastAiPlanBuilderSingle={otherUserInfo?.lastAiPlanBuilderSingle}
                        hasOngoingAiPlanBuilderSingle={otherUserInfo?.hasOngoingAiPlanBuilderSingle}
                        isModalOpen={isModalOpen}
                        planIsFavourite={planIsFavourite}
                        planStressPoints={planStressPoints}
                        setPlanStressPoints={setPlanStressPoints}
                        refFTPForAdjust={refFTPForAdjust}
                        setRefFTPForAdjust={setRefFTPForAdjust}
                        lastNon100FTP={lastNon100FTP}
                        arePlansLoading={arePlansLoading}
                        powerUnit={powerUnit}
                        setPowerUnit={setPowerUnit}
                        siderCollapsed={siderCollapsed}
                        onRequestPremium={openPremiumRequest}
                        setOtherUserInfo={setOtherUserInfo}
                        loginCount={otherUserInfo?.loginCount ?? null}
                        onPlanSetupTourVisibilityChange={(visible) => {
                          try { setSuppressGlobalModals(Boolean(visible)); } catch { }
                        }}
                        // AI Plan Builder page navigation (program)
                        onOpenAiPlanBuilderProgram={openAiPlanBuilderProgram}
                        onResumeAiPlanBuilderProgram={resumeAiPlanBuilderProgram}
                        onOpenAiSingleSessionBuilder={openAiSingleSessionBuilder}
                        onResumeAiSingleSessionBuilder={resumeAiSingleSessionBuilder}
                        persistAiBuilderState={persistAiBuilderState}
                        persistAiSingleBuilderState={persistAiSingleBuilderState}
                      />
                      {showTrainingForm && (
                        <TrainingForm
                          setSteps={setSteps}
                          steps={steps}
                          duplicateSelectedSteps={duplicateSelectedSteps}
                          deleteSelectedSteps={deleteSelectedSteps}
                          setIsModificationMade={setIsModificationMade}
                          createWarmUpSteps={createWarmUpSteps}
                          FTP={FTP}
                          setFTP={setFTP}
                          refFTPForAdjust={refFTPForAdjust}
                          setRefFTPForAdjust={setRefFTPForAdjust}
                          onAdjustPower={onAdjustPower}
                          lastNon100FTP={lastNon100FTP}
                          setLastNon100FTP={setLastNon100FTP}
                          powerUnit={powerUnit}
                          setPowerUnit={setPowerUnit}
                        />
                      )}
                      <Row gutter={16}>
                        <Col
                          span={8}
                          style={{
                            height: planSetupRightStackHeight ? `${planSetupRightStackHeight}px` : undefined,
                          }}
                        >
                          <TrainingList
                            steps={steps}
                            toggleSelectStep={toggleSelectStep}
                            FTP={FTP}
                            reorderSteps={reorderSteps}
                            onOpenTrainingForm={openTrainingForm}
                            fillHeight={Boolean(planSetupRightStackHeight)}
                            powerUnit={powerUnit}
                          />
                        </Col>
                        <Col span={16}>
                          {
                            //<div style={{ maxHeight: "400px" }}>
                          }
                          <div ref={planSetupRightStackRef} style={{ width: "100%" }}>
                            <PlanSetupProgramNavigation
                              username={username}
                              selectedPlan={selectedPlan}
                              planName={planName}
                              planCategory={planCategory}
                              previousUuid={previousUuid}
                              plansInfo={plansInfo}
                              selectPlan={selectPlan}
                              getAllTrainingPlansInfo={getAllTrainingPlansInfo}
                              getPlanLabelByUuid={getPlanLabelByUuid}
                              showTrainingForm={showTrainingForm}
                              isSelectingPlan={isSelectingPlan}
                            />
                            <TrainingChart
                              steps={steps}
                              FTP={FTP}
                              isMobile={isMobile}
                              powerUnit={powerUnit}
                            />
                          </div>
                          {
                            //</div>
                          }
                        </Col>
                      </Row>
                    </>
                  )}
                  {!isMobile && activeKey === "ai_plan_builder" && (
                    <div style={{ marginTop: 8 }}>
                      {aiCoachLoading ? (
                        <LiquidGlass style={{ padding: 24 }}>
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
                            <Spin size="large" />
                            <Text strong>Finding the best Simpl'AI Coach for you…</Text>
                            <Text type="secondary">Analyzing your last sessions and training volume.</Text>
                          </div>
                        </LiquidGlass>
                      ) : (
                        <AiPlansBuilder
                          initialCoachMessage={aiCoachIntroMessage}
                          initialState={aiBuilderInitialState}
                          bootstrap={aiCoachBootstrap}
                          appFtp={FTP}
                          appIsAdmin={isAdmin}
                          appIsPremium={isPremium}
                          onPersistState={persistAiBuilderState}
                          onRequestPremium={openPremiumRequest}
                          onAfterFinalSave={({ uuid } = {}) => {
                            try {
                              const u = uuid ? String(uuid) : "1";
                              getAllTrainingPlansInfo({ uuid: u, username_to_fetch: "" });
                            } catch { }
                          }}
                          onClose={leaveAiPlanBuilder}
                        />
                      )}
                    </div>
                  )}
                  {!isMobile && activeKey === "ai_single_session_builder" && (
                    <div style={{ marginTop: 8 }}>
                      {aiSingleLoading ? (
                        <LiquidGlass style={{ padding: 24 }}>
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
                            <Spin size="large" />
                            <Text strong>Warming up your Simpl'AI Coach…</Text>
                            <Text type="secondary">We’ll build one workout session together.</Text>
                          </div>
                        </LiquidGlass>
                      ) : (
                        <AiIndividualSessionBuilder
                          initialCoachMessage={aiSingleIntroMessage}
                          initialState={aiSingleBuilderInitialState}
                          bootstrap={aiSingleBootstrap}
                          appFtp={FTP}
                          appIsAdmin={isAdmin}
                          appIsPremium={isPremium}
                          onPersistState={persistAiSingleBuilderState}
                          onRequestPremium={openPremiumRequest}
                          onAfterSave={(uuid) => {
                            try {
                              const u = uuid ? String(uuid) : "1";
                              getAllTrainingPlansInfo({ uuid: u, username_to_fetch: "" });
                            } catch { }
                          }}
                          onClose={leaveAiSingleSessionBuilder}
                        />
                      )}
                    </div>
                  )}
                  {!isMobile && activeKey === "2" && (
                    <Row>
                      <Col span={24}>
                        <HomeTrainer
                          onConnect={(device) =>
                            console.log("Connected to", device.name)
                          }
                          onDisconnect={() => console.log("Disconnected")}
                          initSteps={steps}
                          FTP={FTP}
                          setStepIndex={setStepIndex}
                          isAdmin={isAdmin}
                          setFTP={setFTP}
                          setWeight={setWeight}
                          weight={weight}
                          username={username}
                          plansInfo={plansInfo}
                          completedSessionsCount={
                            typeof progressCount === "number"
                              ? progressCount
                              : Array.isArray(history)
                                ? history.length
                                : 0
                          }
                          completedSessionsCountLoaded={typeof progressCount === "number"}
                          planCategoryForNav={planCategory}
                          previousUuid={previousUuid}
                          selectPlan={selectPlan}
                          getAllTrainingPlansInfo={getAllTrainingPlansInfo}
                          getPlanLabelByUuid={getPlanLabelByUuid}
                          infoToSave={{
                            isModificationMade,
                            selectedPlan,
                            planName,
                            otherUserInfo,
                          }}
                          otherUserInfo={otherUserInfo}
                          setOtherUserInfo={setOtherUserInfo}
                          isMobile={isMobile}
                          setDisabledPhoneButton={setDisabledPhoneButton}
                          isMute={isMute}
                          onToggleMute={() => setIsMute((m) => !m)}
                          goToPlanSetup={goToPlanSetup}
                          showModal={showModal}
                          isModalOpen={isModalOpen}
                          onRequestPremium={openPremiumRequest}
                          siderCollapsed={siderCollapsed}
                          onSessionSavedUiConfirmed={devFeedback?.onSessionSavedUiConfirmed}
                        />
                      </Col>

                    </Row>
                  )}
                  {isMobile && activeKey === "3" && (
                    <>
                      <div className="glass-panel glass-section" style={{ marginBottom: 0, paddingBottom: 0 }}>
                        <Row gutter={16}>
                          <Col span={2}>
                            <FileImporter setPlanName={setPlanName} setSteps={setSteps} setFTP={setFTP} setDescription={setPlanDescription} FTP={FTP} steps={steps} planName={planName} description={planDescription} createWarmUpSteps={createWarmUpSteps} isMobile={isMobile} />
                          </Col>
                          <Col span={5}>
                            <Form.Item>
                              <Input
                                disabled={disabledPhoneButton}
                                placeholder="Plan's Username"
                                onChange={(e) =>
                                  setUsernameToFetch(e.target.value)
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                          <Col
                            span={1}
                            style={{ display: "flex", justifyContent: "center" }}
                          >
                            <Form.Item>
                              <ReloadOutlined
                                style={{ fontSize: "20px" }}
                                onClick={() => !disabledPhoneButton && getAllTrainingPlansInfo({ uuid: 1 })}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={8}>
                            {" "}
                            <Select

                              block
                              disabled={disabledPhoneButton}
                              dropdownStyle={{ width: "80%" }}
                              dropdownAlign={{
                                points: ['tl', 'bl'], // Align the top-left of dropdown to bottom-left of select
                                offset: ["30%", 0], // Move dropdown 50px to the right
                              }}
                              style={{ width: "100%" }}
                              showSearch={true}
                              optionFilterProp="label"
                              onChange={(value) => {
                                isModificationMade ||
                                  (planName && planName != selectedPlan.name) ||
                                  (planDescription &&
                                    planDescription != selectedPlan.description) ||
                                  (planCategory &&
                                    planCategory != selectedPlan.category)
                                  ? showModal(value)
                                  : selectPlan(value, plansInfo);
                              }}
                              value={selectedPlan.uuid}
                              placeholder="Choose existing plan"
                            >
                              {[
                                { uuid: 1, display_name: arePlansLoading ? "Training sessions are loading..." : `Select training session (${plansInfo.length} sessions loaded${usernameToFetch ? ", filter applied" : ""})` },
                                ...plansInfo,
                              ]
                                .sort((a, b) => {
                                  if (a.uuid == "1") {
                                    return -10;
                                  } else if (b.uuid == "1") {
                                    return 10;
                                  }
                                  if (
                                    a.display_name.includes("❤") &&
                                    !b.display_name.includes("❤")
                                  ) {
                                    return -1;
                                  } else if (
                                    !a.display_name.includes("❤") &&
                                    b.display_name.includes("❤")
                                  ) {
                                    return 1;
                                  } else {
                                    if (
                                      a.username == username &&
                                      b.username != username
                                    ) {
                                      return -1;
                                    } else if (
                                      a.username != username &&
                                      b.username == username
                                    ) {
                                      return 1;
                                    } else {
                                      return a.display_name < b.display_name
                                        ? -1
                                        : 1;
                                    }
                                  }
                                })
                                .map((planInfo, i) => (
                                  <Option
                                    key={planInfo.uuid}
                                    label={planInfo.display_name}
                                    value={planInfo.uuid}
                                    style={{
                                      whiteSpace: "normal", // Permet de diviser le texte en plusieurs lignes
                                      wordBreak: "break-word", // Coupe les mots trop longs s'ils dépassent la largeur
                                    }}
                                  >
                                    {planInfo.display_name}
                                  </Option>
                                ))}
                            </Select>
                          </Col>
                          <Col
                            span={1}
                            style={{ display: "flex", justifyContent: "left" }}
                          >
                            <Form.Item>
                              {planIsFavourite ? (
                                <HeartFilled
                                  style={{ color: "red", fontSize: "20px" }}
                                  onClick={() =>
                                    !disabledPhoneButton && setFavourite({ favourite: false })
                                  }
                                />
                              ) : (
                                <HeartOutlined
                                  disabled={true}
                                  style={{ color: "black", fontSize: "20px" }}
                                  onClick={() =>
                                    setFavourite({ favourite: true })
                                  }
                                />
                              )}
                            </Form.Item>
                          </Col>
                          <Col span={5}>
                            <Form.Item
                              help={
                                selectedPlan.ref_ftp
                                  ? `Plan FTP : ${selectedPlan.ref_ftp}W. Last ref : (${refFTPForAdjust}W).`
                                  : refFTPForAdjust != FTP
                                    ? `Last ref FTP : ${refFTPForAdjust}`
                                    : ""
                              }
                            >
                              <Input
                                type="number"
                                addonAfter="Watts"
                                value={FTP}
                                disabled={disabledPhoneButton}
                                onPressEnter={() => {
                                  try {
                                    const MIN_FTP = 20;
                                    const nRaw = Number(FTP);
                                    const n = Number.isFinite(nRaw) && nRaw > 0 ? nRaw : MIN_FTP;
                                    onAdjustPower({ nextFtp: Math.max(MIN_FTP, Math.round(n)) });
                                  } catch { }
                                }}
                                onChange={(e) => {
                                  try {
                                    const v = e?.target?.value;
                                    // Clearing the input should not produce NaN (which later gets coerced to 20).
                                    if (v === "" || v === null || v === undefined) {
                                      setFTP(null);
                                      return;
                                    }
                                    const n = Number(v);
                                    if (!Number.isFinite(n) || n < 0) return;
                                    setFTP(Math.round(n));
                                  } catch { }
                                }}
                              />
                            </Form.Item>
                          </Col>
                          {/* Adjust button removed: FTP auto-adjusts after 2s idle (and on Enter) */}
                        </Row>
                      </div>
                      <p />
                      <Row>
                        <Col span={24}>
                          <HomeTrainer
                            onConnect={(device) =>
                              console.log("Connected to", device.name)
                            }
                            onDisconnect={() => console.log("Disconnected")}
                            initSteps={steps}
                            FTP={FTP}
                            setStepIndex={setStepIndex}
                            isAdmin={isAdmin}
                            setFTP={setFTP}
                            setWeight={setWeight}
                            weight={weight}
                            username={username}
                            plansInfo={plansInfo}
                            planCategoryForNav={planCategory}
                            previousUuid={previousUuid}
                            selectPlan={selectPlan}
                            getAllTrainingPlansInfo={getAllTrainingPlansInfo}
                            getPlanLabelByUuid={getPlanLabelByUuid}
                            infoToSave={{
                              isModificationMade,
                              selectedPlan,
                              planName,
                              otherUserInfo,
                            }}
                            otherUserInfo={otherUserInfo}
                            setOtherUserInfo={setOtherUserInfo}
                            isMobile={isMobile}
                            setDisabledPhoneButton={setDisabledPhoneButton}
                            isMute={isMute}
                            onToggleMute={() => setIsMute((m) => !m)}
                            goToPlanSetup={goToPlanSetup}
                            showModal={showModal}
                            isModalOpen={isModalOpen}
                            onRequestPremium={openPremiumRequest}
                            siderCollapsed={siderCollapsed}
                            onSessionSavedUiConfirmed={devFeedback?.onSessionSavedUiConfirmed}
                          />
                        </Col>
                      </Row>
                      <p />
                    </>
                  )}
                  {activeKey === "4" && (
                    <History
                      history={history}
                      isMobile={isMobile}
                      onRefresh={() => refreshUserInfoAndHistory({ includeHistory: true, validateStrava: false, fetchShouldRideOutside: false })}
                      refreshing={isRefreshingHistory}
                    />
                  )}
                  {activeKey === "admin_user_history" && isAdmin && (
                    <AdminUserHistory
                      username={adminUserHistoryUsername}
                      axiosInstance={axiosInstance}
                      isMobile={isMobile}
                      onBack={backToAdminDashboard}
                    />
                  )}
                  {activeKey === "5" && (
                    <Spin spinning={!!isRefreshingHistory} tip="Loading history...">
                      <TrainingSummary initData={history}></TrainingSummary>
                    </Spin>
                  )}
                  {isAdmin && activeKey === "6" && (
                    <AdminDashboard onOpenUserHistory={openAdminUserHistory} />
                  )}
                  {isAdmin && activeKey === "7" && (
                    <WorkoutParser />
                  )}
                  {activeKey === "profile" && (
                    <Profile
                      username={username}
                      otherUserInfo={otherUserInfo}
                      isPremium={isPremium}
                      FTP={FTP}
                      weight={weight}
                      setFTP={setFTP}
                      setWeight={setWeight}
                      setOtherUserInfo={setOtherUserInfo}
                    />
                  )}
                </div>
                <div
                  style={{ margin: "10%", display: !isLandscape ? true : "none" }}
                >



                  <div
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={logoTurnPhone}
                      style={{ height: "150px", marginTop: "20vh" }}
                      alt="SimplyRide.app"
                    />
                  </div>
                  <small
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    Please turn your phone
                  </small>
                  <small
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "20px",
                    }}
                  >
                    SimplyRide.app
                  </small>
                </div>
              </div>
            </Content>
            {/* Footer removed for authenticated app; footer links moved to sidebar bottom */}
          </Layout>
        </Layout >
      </InstallProvider>
    );
  } else {
    return (
      <>
        <InstallProvider>
          <Layout
            style={{
              minHeight: "100vh",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "rgba(22, 40, 226, 0.05)",
            }}
          >
            <Content style={{ flex: "1 1 0%", minHeight: 0, overflow: "auto", padding: "20px" }}>
              <LoginForm
                username={username}
                setUsername={setUsername}
                setHistory={setHistory}
                title={title}
                slogan={slogan}
                setIsAdmin={setIsAdmin}
                setIsPremium={setIsPremium}
                setIsBetaTester={setIsBetaTester}
                setFTP={setFTP}
                setWeight={setWeight}
                setFavouritePlans={setFavouritePlans}
                isMobile={isMobile}
                reloadTs={reloadTs}
                setOtherUserInfo={setOtherUserInfo}
                setNextSessionUuid={setNextSessionUuid}
                rideOutsideProposed={rideOutsideProposed}
                setRideOutsideProposed={setRideOutsideProposed}
                appBootstrappingUserInfo={isBootstrappingUserInfo}
                refreshUserInfoAndHistory={refreshUserInfoAndHistory}
              />
            </Content>
            <AppFooter isMobile={isMobile} backendBaseUrl={backendBaseUrl} />
            {/* Feedback / Bug modal for unauthenticated users */}
            <FeedbackBugReports
              open={isFeedbackOpen}
              mode={feedbackMode}
              onClose={() => {
                setIsFeedbackOpen(false);
                setFeedbackInitialText("");
              }}
              axiosInstance={axiosInstance}
              alertDlg={alertDlg}
              initialScreenshot={initialBugScreenshot}
              initialText={feedbackInitialText}
            />
            {!suppressGlobalModals ? devFeedback?.modals : null}
          </Layout>
        </InstallProvider>
      </>
    );
  }
}

function App() {
  const pathname = (window.location && window.location.pathname) || "/";
  const isLanding = pathname === "/landing" || pathname.startsWith("/landing/");
  const isRoot = pathname === "/" || pathname === "";

  // If the app is installed as a PWA, do NOT redirect to the marketing landing page.
  // (Users expect the app to open directly to the app/login screen.)
  let isPwa = false;
  try {
    isPwa =
      (typeof window !== "undefined" &&
        window.matchMedia &&
        window.matchMedia("(display-mode: standalone)").matches) ||
      // iOS Safari
      (typeof window !== "undefined" &&
        window.navigator &&
        window.navigator.standalone === true);
  } catch {
    isPwa = false;
  }

  let hasToken = false;
  let landingShown = false;
  try {
    const raw = localStorage.getItem("token");
    const tok = typeof raw === "string" ? raw.trim() : "";
    // Guard against common "junk" string values
    hasToken = Boolean(tok && tok !== "null" && tok !== "undefined");
    landingShown = localStorage.getItem("isLandingShown") === "true";
  } catch {
    // ignore storage errors
  }

  const shouldIntroRedirect = isRoot && !isLanding && !hasToken && !landingShown && !isPwa;
  if (shouldIntroRedirect) {
    try {
      window.location.replace("/landing");
    } catch {
      try {
        window.location.href = "/landing";
      } catch {
        // ignore
      }
    }
    return null;
  }
  if (isLanding) {
    return (
      <InstallProvider>
        <LandingPage />
      </InstallProvider>
    );
  }
  return <AppMain />;
}

export default App;

